import AboutPage from '@/pages/about/AboutPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/about/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AboutPage />;
}
